import React from "react";
import { useNavigate } from "react-router-dom";
import ExperienceActionPresentation from "../../presentation/experience.action.presentation/ExperienceActionPresentation";
type ExperienceActionContainerProps = {
  onTerm: (e: React.ChangeEvent<HTMLInputElement>) => void;
  listStatus: string;
  onPublish: () => void;
  onSave: () => void;
  term: string;
  lastPosition: number;
};
const ExperienceActionContainer: React.FC<ExperienceActionContainerProps> = ({
  onTerm,
  listStatus,
  onSave,
  onPublish,
  term,
  lastPosition,
}) => {
  const navigation = useNavigate()
  const onCreateExperience = () => {
    navigation('/experience/expdetails',{state : {isPrerequisites : false, lastPosition : lastPosition}})
  }

  return (
    <ExperienceActionPresentation
      onCreateExperience={onCreateExperience}
      onTerm={onTerm}
      listStatus={listStatus}
      onSave={onSave}
      onPublish={onPublish}
      term={term}
    />
  )
}

export default ExperienceActionContainer
